<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Date">
          <a-date-picker
            placeholder="Select Date"
            :disabled="true"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.tanggal,
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Type R&D Notification">
          <a-radio-group
            buttonStyle="solid"
            v-decorator="['type_rnd',{rules: [{ required: true }],initialValue: initialData.informasi.type_rnd,},]"
            disabled
          >
            <a-radio-button value="1">Type 1</a-radio-button>
            <a-radio-button value="2">Type 2</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <!-- <a-form-item label="Project Code">
          <a-input
            v-decorator="[
              'project_nm',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.project_nm,
              },
            ]"
          ></a-input>
        </a-form-item> -->
        <a-form-item label="Description">
          <a-input
            v-decorator="[
              'deskripsi',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.deskripsi,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Customer Name">
          <a-select
            v-decorator="[
              'customer_id',
              {
                rules: [
                  { required: true, message: 'Customer Name Required' },
                ],
                initialValue: initialData.informasi.customer_id,
              },
            ]"
            showSearch
            option-filter-prop="children" :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in listCustomer"
              :key="item.customer_id"
              :value="item.customer_id"
              >{{ item.customer_code }} - {{ item.customer_nm }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Spesial Requirment">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="[
              'special_requirement',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.special_requirement,
              },
            ]"
          />
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Periode Development">
          <a-range-picker :placeholder="['Start Date', 'End Date']"
            v-decorator="[
              'periode',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.periode,
              },
            ]"
            :format="getDefaultDateFormat" allowClear />
        </a-form-item>
        <a-form-item label="Due Date">
          <!-- <a-input
            v-decorator="[
              'due_date',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.due_date,
              },
            ]"
          ></a-input> -->
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="[
              'due_date',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.due_date,
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="Estimated Project Value">
          <a-input-number
            :max="999999999999"
            :min="0"
            class="m-width-full"
            v-decorator="[
              'estimate_project_val',
              {
                rules: [{ required: true },{validator: validRatherThenzero} ],
                initialValue: initialData.informasi.estimate_project_val,
              },
            ]"
          ></a-input-number>
        </a-form-item> -->
        <a-form-item label="Estimated Project Cost (IDR)">
          <!-- <a-input
            v-decorator="[
              'estimate_project_cost',
              {
                rules: [],
                initialValue: initialData.informasi.estimate_project_cost,
              },
            ]"
          ></a-input> -->
          <a-input-number
            :max="999999999999"
            :min="0"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            class="m-width-full"
            v-decorator="[
              'estimate_project_cost',
              {
                rules: [{ required: true },{validator: validRatherThenzero}],
                initialValue: initialData.informasi.estimate_project_cost,
              },
            ]"
          ></a-input-number>
        </a-form-item>
        <!-- <a-form-item label="Bid Reasoning">
          <a-input
            v-decorator="[
              'bid_reasoning',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.bid_reasoning,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="UP/RFQ Number">
          <a-input
            v-decorator="[
              'up_rfq_no',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.up_rfq_no,
              },
            ]"
          ></a-input>
        </a-form-item> -->
        <a-form-item label="PIMPRO">
          <a-select
            showSearch
            allowClear
            optionFilterProp="children"
            :filterOption="filterOption"
            v-decorator="[
              'pimpro',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.pimpro,
              },
            ]">
              <a-select-option
                v-for="item in listBawahan"
                :key="item.tlc"
                :value="item.tlc"
                >{{ item.tlc }} - {{ item.nama }}</a-select-option
              >
            </a-select>
        </a-form-item>
        <a-form-item label="Executor Site">
          <a-select
            :disabled="mode === 'Edit' ? true : false"
            class="m-width-full"
            v-decorator="[
              'executor_site',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.executor_site,
              },
            ]"
          >
            <a-select-option value="Site Surabaya"
              >Site Surabaya</a-select-option
            >
            <a-select-option value="Site Jakarta">Site Jakarta</a-select-option>
          </a-select>
          <!-- <a-input
            v-decorator="[
              'executor_site',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.executor_site,
              },
            ]"
          ></a-input> -->
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
export default {
  name: "Informasi",
  props: {
    data: {},
    persetujuan: {},
    listCustomer: {},
    listBawahan: {},
    mode: String,
  },
  mixins: [GlobalMethod,],
  data() {
    return {
      activeProject: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat","getAllKaryawan"]),
    isFromAtasanLangsung(){
      return localStorage.getItem("nvky")=='54' ? true : false
    },
    initialData() {
      let informasi = {};
      let pimpinan = {};
      if (this.data === undefined || this.data.length <= 0) {
        informasi = {
          tanggal: moment(),
          //project_nm: "",
          deskripsi: "",
          customer_nm: "",
          customer_id: "",
          periode: [null,null],
          due_date: "",
          special_requirment: "",
          estimate_project_val: "0",
          estimate_project_cost: "0",
          // bid_reasoning: "",
          // up_rfq_no: "",
          executor_site: "",
          pimpro: "",
          type_rnd: this.isFromAtasanLangsung ? "1" : "2"
        };
        return { informasi };
      } else {
        informasi = {
          tanggal: moment(this.data.tanggal),
          //project_nm: this.data.project_nm,
          deskripsi: this.data.deskripsi,
          customer_nm: this.data.customer_nm,
          customer_id: this.data.customer_id,
          periode: this.data.periode,
          due_date: moment(this.data.due_date),
          special_requirement: this.data.special_requirement,
          estimate_project_val: this.data.estimate_project_val,
          estimate_project_cost: this.data.estimate_project_cost,
          // bid_reasoning: this.data.bid_reasoning,
          // up_rfq_no: this.data.up_rfq_no,
          executor_site: this.data.executor_site,
          pimpro: this.data.pimpro,
          type_rnd: this.data.type_rnd
        };

        // if (this.persetujuan === undefined || this.persetujuan.length <= 0) {
        //   pimpinan = {
        //     bod: "",
        //     pimpro: "",
        //   };
        // } else {
        //   pimpinan = {
        //     bod: this.persetujuan.bod,
        //     pimpro: this.persetujuan.pimpro,
        //   };
        // }

        return { informasi, pimpinan };
      }
    },
  },
  created() {
    this.$store.dispatch("FETCH_PRODUKRND");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
  },
  methods: {
    moment,
    handleProject(value) {
      let filter = this.project.filter(
        (obj) =>
          obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      this.initialData.pimpinan.pimpro = filter[0].pimpro;
      this.initialData.pimpinan.bod = filter[0].bod;
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let csnm = _.filter(this.listCustomer,(e)=> e.customer_id==values.customer_id)
        values.customer_nm = csnm[0].customer_nm
        Event.$emit("SalesNotifData", {
          informasi: values,
        });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style>
</style>